<template>
  <button :class="'yz-button '+type" @click="handleClick">
    <slot></slot>
  </button>
</template>
<script>
export default {
  props: {
    type: {
      type: String,
      default: 'yz-button'
    }
  },
  data() {
    return {

    };
  },
  methods: {
    handleClick(evt) {
      this.$emit('click', evt);
    },
  }
};
</script>

<style lang="less">
.yz-button {
    display: inline-block;
    line-height: 1;
    white-space: nowrap;
    cursor: pointer;
    background: #fff;
    -webkit-appearance: none;
    text-align: center;
    box-sizing: border-box;
    outline: none;
    margin: 0 5px 0 0;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    min-width: 50px;
    line-height: 26px;
    padding: 0 12px;
    font-size: 12px;
    border: 1px solid #bfcbd9;
    border-color: #c4c4c4;
    border-radius: 4px;
    -webkit-transition: 0.1s;
    &.primary {
        background-color: #ffffff;
        &:hover {
            background-color: #edf5ff;
            border-color: #b3d9ff;
        }
    }
    &.forbidden {
        background-color: #ffffff;
        opacity: 0.5;
    }
    &.delete {
        border-color: #d8dce5;
        color: #5a5e66;
        background-color: #ffffff;
        &:hover {
            background-color: #f5f5f5;
            border-color: #d8dce5;
        }
    }
    &.disabled {
        color: #c0c4cc;
        border: 1px solid #c0c4cc;
        background-color: #ffffff;
        &:hover {
            background-color: #f5f5f5;
            border-color: #c0c4cc;
            cursor: no-drop;
        }
    }
}
</style>
